
let host = '';
let url = '';


if (process.env.REACT_APP__PUBLIC_ENVIROMENT === 'localhost') {
    host = 'http://localhost:9001';
    url = 'http://localhost:3000';
}
else if(process.env.REACT_APP__PUBLIC_ENVIROMENT === 'SIT1') {
    host = 'https://sit1-apiai-jaminyjobportal.innov.co.in';
    url = 'https://sit1-uiai-jaminyjobportal.innov.co.in';
}
else if(process.env.REACT_APP__PUBLIC_ENVIROMENT === 'UAT1') {
    host = '';
    url = '';
}
else if(process.env.REACT_APP__PUBLIC_ENVIROMENT === 'production') {
    host = 'https://api.teacherprofinder.com';
    url = 'https://teacherprofinder.com';
}

// Optional override, e.g. a same-origin reverse proxy on a test server.
if (process.env.REACT_APP_API_DOMAIN) {
    host = process.env.REACT_APP_API_DOMAIN;
}

export const domain = host;
export const websiteUrl = url;
export const basicAuth = 'dG1zdGhlcmFwaXN0OiQyYSQxMiRTNUcxSy8vcXFHQ1NHYnNKcXQuRXRPLlhJNjllV3BnQVM2LzBCVDJCcTcxbE1XLnMzL1NGVw==';
export const storageTokenKeyName = 'token';
export const temporaryStorageTokenKeyName = 'tempToken';



